import MinuteByMinute from '../../turboLive/components/minute-by-minute/MinuteByMinute';
import React from 'react';
import BetradarMTStatisticsExtended from './betradar-widgets/betradar-statitics-widgets/BetradarMTStatisticsExtended';
import BetradarMTTeamStatistics from './betradar-widgets/betradar-statitics-widgets/BetradarMTTeamStatistics';
import BetradarMTStatisticsMatchFacts from './betradar-widgets/betradar-statitics-widgets/BetradarMTStatisticsMatchFacts';
import BetradarMTStatisticsVerticalTimeline from './betradar-widgets/betradar-statitics-widgets/BetradarMTStatisticsVerticalTimeline';
import BetradarMTStatisticsCommentary from './betradar-widgets/betradar-statitics-widgets/BetradarMTStatisticsCommentary';
import BetradarMTStatisticsTable from './betradar-widgets/betradar-statitics-widgets/BetradarMTStatisticsTable';
import BetradarMTStatisticsMatchLineups from './betradar-widgets/betradar-statitics-widgets/BetradarMTStatisticsMatchLineups';
import BetradarMTStatisticsHeatMap from './betradar-widgets/betradar-statitics-widgets/BetradarMTStatisticsHeatMap';
import BetradarMTStatistics from './betradar-widgets/betradar-statistics-basic/BetradarMTStatistics';
import BetradarMTTopLists from './betradar-widgets/betradar-statitics-widgets/BetradarMTTopLists';
import {
    COMMENTARY,
    GENERAL_STATISTICS,
    GENERAL_TEAM_STATISTICS,
    HEAT_MAP,
    IMG_ARENA_EVENT_CENTRE,
    MATCH_FACTS,
    MATCH_LINEUPS,
    MBM,
    TABLE,
    TOP_LISTS,
    VERTICAL_TIMELINE
} from '../utils';
import MatchStatisticsScrollable from './MatchStatisticsScrollable';
import IMGEventCentre from './img-event-centre/IMGEventCentre';
import { ErrorBoundary } from '../../../common/ErrorBoundary';
import { getSportNameById } from '../../../common/utils/utils';

function MatchStatisticsContent({ active, matchId, sportId, eventId, sportCode, activeTab, ufcEventId, tournamentId }) {
    return (
        <ErrorBoundary description="MatchStatisticsContent">
            {active === GENERAL_STATISTICS ? (
                <BetradarMTStatisticsExtended matchId={matchId} sportId={sportId} />
            ) : active === GENERAL_TEAM_STATISTICS ? (
                <BetradarMTTeamStatistics matchId={matchId} />
            ) : active === MATCH_FACTS ? (
                <BetradarMTStatisticsMatchFacts matchId={matchId} />
            ) : active === VERTICAL_TIMELINE ? (
                <BetradarMTStatisticsVerticalTimeline matchId={matchId} />
            ) : active === COMMENTARY ? (
                <BetradarMTStatisticsCommentary matchId={matchId} />
            ) : active === TABLE ? (
                <BetradarMTStatisticsTable matchId={matchId} />
            ) : active === MATCH_LINEUPS ? (
                <BetradarMTStatisticsMatchLineups matchId={matchId} />
            ) : active === HEAT_MAP ? (
                <BetradarMTStatisticsHeatMap matchId={matchId} />
            ) : active === TOP_LISTS ? (
                <BetradarMTTopLists matchId={matchId} />
            ) : active === IMG_ARENA_EVENT_CENTRE ? (
                <IMGEventCentre matchId={matchId} ufcEventId={ufcEventId} tournamentId={tournamentId} />
            ) : active === MBM ? (
                <MatchStatisticsScrollable className="bg-black-3">
                    <MinuteByMinute
                        matchId={eventId}
                        sportCode={getSportNameById(sportId, false)}
                        sportName={sportCode}
                    />
                </MatchStatisticsScrollable>
            ) : matchId ? (
                <BetradarMTStatistics
                    matchId={matchId}
                    tab={active}
                    streamStatistics={activeTab && activeTab === 'VIDEO'}
                    sportId={sportId}
                />
            ) : null}
        </ErrorBoundary>
    );
}

export default MatchStatisticsContent;
